var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.580078,
    y: 0.579987,
    width: 18.84,
    height: 18.84,
    rx: 2,
    fill: "#C1C9DC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.51962 7.172C3.57828 7.172 3.62762 7.17466 3.66762 7.18C3.70762 7.18533 3.74362 7.196 3.77562 7.212C3.80762 7.22533 3.83828 7.24533 3.86762 7.272C3.89695 7.29866 3.93028 7.33466 3.96762 7.38L6.73562 10.88C6.72495 10.768 6.71695 10.66 6.71162 10.556C6.70628 10.4493 6.70362 10.3493 6.70362 10.256V7.172H7.89562V13H7.19162C7.08762 13 6.99962 12.984 6.92762 12.952C6.85562 12.92 6.78628 12.8613 6.71962 12.776L3.97162 9.304C3.97962 9.40533 3.98628 9.50533 3.99162 9.604C3.99695 9.7 3.99962 9.79066 3.99962 9.876V13H2.80762V7.172H3.51962Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6065 7.172V8.212H10.2145V9.688H12.2065V10.732H10.2145V13H8.85449V7.172H12.6065Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5396 7.172V8.244H15.8996V13H14.5476V8.244H12.9076V7.172H17.5396Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNft);
export default __webpack_public_path__ + "static/media/nft.c6d2b5d4a3c37dd1a1af2992b603be20.svg";
export { ForwardRef as ReactComponent };